var map = {
	"./de-DE.json": "36a9",
	"./en-GB.json": "d1b2",
	"./en-US.json": "fadc",
	"./es-ES.json": "7d56",
	"./fr-CA.json": "7346",
	"./fr-FR.json": "ee04",
	"./it-IT.json": "0a9c",
	"./ja-JP.json": "d9d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82a7";